<div class="d-flex">
  <p *ngIf="props.description" class="mb-1" [innerHtml]="props.description"></p>
  <lui-avatar
    *ngIf="props.tooltip"
    color="primary"
    class="dynamic-field__tooltip ms-1"
    size="20px"
    [matTooltip]="props.tooltip.text"
    [useClickListener]="true"
  >
    <mat-icon svgIcon="i"></mat-icon>
  </lui-avatar>
</div>

<div *ngIf="internalForm.length > +addingAnother" class="d-flex flex-wrap">
  <ng-container *ngIf="props.cache.toggleList">
    <div
      class="w-100"
      *ngIf="
        internalForm.controls.length <=
          (props.cache.toggleList.breakpoint || Infinity) || props.print;
        else toggleListTmpl
      "
    >
      <ng-container
        *ngFor="let form of internalForm.controls; let index = index"
      >
        <ng-container *ngIf="itemInEdit !== index">
          <ng-container
            *ngTemplateOutlet="
              cardTmpl;
              context: {
                $implicit: { item: form.value, invalid: form.invalid, index }
              }
            "
          ></ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="props.cache.table">
    <ng-container
      *ngTemplateOutlet="tableTmpl; context: { $implicit: props.cache.table }"
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="props.cache.calcTable">
    <ng-container
      *ngTemplateOutlet="
        calcTableTmpl;
        context: { $implicit: props.cache.calcTable }
      "
    ></ng-container>
  </ng-container>
</div>

<div [className]="props.fieldsClassName">
  <div
    class="mt-1"
    [ngClass]="{
      'mt-1': !!props.description || internalForm.controls.length > 1,
      'd-none': itemInEdit | isNil,
      'border-top': props.cache.table,
      'pt-4': props.cache.table
    }"
    [attr.id]="field.key"
  >
    <formly-form
      *ngFor="let form of internalForm.controls; let index = index"
      class="d-block mx-auto"
      [ngClass]="{
          'd-none': itemInEdit !== index,
          'mw-md': props.cache.table,
        }"
      [form]="$any(form)"
      [options]="internalOptions"
      [fields]="fields[index]"
    ></formly-form>
  </div>

  <div class="mt-1" *ngIf="!props.readonly && !props.print">
    <div class="mb-2" *ngIf="props.cache.table">
      <mat-divider></mat-divider>
    </div>

    <div *ngIf="props.min || props.max" class="mb-2">
      <span>
        <ng-container i18n>Added</ng-container>
        <strong> {{ addedItemsCount }} </strong>
        <ng-container>{{
          addedItemsCount | i18nPlural : { '=1': 'entry', other: 'entries' }
        }}</ng-container>
      </span>

      <span *ngIf="props.min" class="mb-2">
        <ng-container i18n> out of</ng-container>
        <strong> {{ props.min }} </strong>
        <ng-container i18n>required</ng-container>
      </span>

      <span *ngIf="props.max" class="mb-2">
        (<ng-container i18n>maximum of</ng-container>
        <strong> {{ props.max }}</strong
        >)
      </span>

      <mat-error *ngIf="formControl.hasError('min')">
        <ng-container i18n>At least</ng-container>
        <strong> {{ props.min }} </strong>
        <ng-container i18n>entries are required</ng-container>
      </mat-error>
    </div>

    <div class="d-flex justify-content-between flex-row-reverse">
      <ng-container [ngSwitch]="mode">
        <ng-container *ngSwitchCase="modes.AddAnother">
          <div></div>

          <ng-container *ngIf="!isCurrentEmpty || (itemInEdit | isNil)">
            <ng-container
              *ngTemplateOutlet="
                addAnotherControl;
                context: {
                  $implicit: { disabled: addedItemsCount >= props.max }
                }
              "
            ></ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="modes.Create">
          <button
            class="d-flex"
            luiButton
            size="lg"
            type="button"
            [disabled]="!canSave"
            (click)="saveChanges()"
            i18n
            >{{ props.saveText }}</button
          >
          <ng-container *ngIf="!itemInEdit && props.startEmpty && min < 1">
            <button
              class="d-flex"
              iconPosition="start"
              luiCab
              size="lg"
              type="button"
              (click)="delete(0)"
            >
              <mat-icon svgIcon="delete"></mat-icon>
              {{ props.cancelText }}
            </button>
          </ng-container>

          <button
            *ngIf="itemInEdit"
            class="d-flex"
            iconPosition="start"
            luiCab
            size="lg"
            type="button"
            (click)="delete(itemInEdit)"
          >
            <mat-icon svgIcon="delete"></mat-icon>
            {{ props.cancelText }}
          </button>
        </ng-container>

        <ng-container *ngSwitchCase="modes.Update">
          <button luiButton type="button" (click)="saveChanges()">{{
            props.saveChangesText
          }}</button>

          <button
            class="d-flex"
            iconPosition="start"
            luiCab
            size="lg"
            type="button"
            (click)="cancelEdit()"
          >
            <mat-icon svgIcon="delete"></mat-icon>
            {{ props.cancelText }}
          </button>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #calcTableTmpl let-cache>
  <lockton-apps-dynamic-form-calc-table
    class="w-100"
    [distinctBy]="cache.distinctBy"
    [total]="cache.total"
    [cells]="cache.cells"
    [fields]="props.fields"
    [rows]="(rows$ | async) || []"
    (edit)="edit($event)"
    (delete)="delete($event)"
    (customEvent)="onCustomEvent($event)"
    (animationDone)="scrollToForm($event)"
  ></lockton-apps-dynamic-form-calc-table>
</ng-template>

<ng-template #tableTmpl let-cache>
  <lockton-apps-dynamic-form-table
    class="w-100"
    [label]="cache.totalLabel"
    [limit]="props.print ? Infinity : cache.visibilityLimit"
    [totalCountFilter]="cache.totalCountFilter"
    [rows]="(rows$ | async) || []"
    [fields]="props.fields"
    [readonly]="props.readonly"
    [print]="props.print"
    (edit)="edit($event)"
    (delete)="delete($event)"
    (customEvent)="onCustomEvent($event)"
    (animationDone)="scrollToForm($event)"
  ></lockton-apps-dynamic-form-table>
</ng-template>

<ng-template #toggleListTmpl>
  <la-toggle-list
    *ngIf="props.cache.toggleList"
    class="d-block mb-3"
    [totalLabel]="props.cache.toggleList.totalLabel"
    [visibilityLimit]="props.cache.toggleList.visibilityLimit"
    [multi]="props.cache.toggleList.multi"
  >
    <ng-container *ngFor="let form of internalForm.controls; let index = index">
      <la-toggle-list-item
        *ngIf="itemInEdit !== index"
        [class.la-toggle-list-item--invalid]="form.invalid"
      >
        <div *laToggleListItemTitle>
          <ng-container
            *ngrxLet="{
              key: $any(props.cache.toggleList).distinctBy,
              value: form.value | get : $any(props.cache.toggleList).distinctBy
            } as pair"
          >
            <lockton-apps-dynamic-form-cell
              *ngIf="pair | fieldMeta : fields[index] as meta"
              [type]="meta.type"
              [value]="pair.value"
              [parentValue]="form.value"
              [addonLeft]="meta.addonLeft"
              [addonRight]="meta.addonRight"
              [decimalFormat]="meta.decimalFormat"
              [options]="meta.options$ | async"
              [displayWith]="meta.displayWith"
              (customEvent)="onCustomEvent($event)"
            ></lockton-apps-dynamic-form-cell>
          </ng-container>
        </div>
        <div class="mx-2 pb-2 border-top">
          <ng-container
            *ngTemplateOutlet="
              cardTmpl;
              context: {
                $implicit: {
                  item: form.value,
                  expansion: true,
                  index
                }
              }
            "
          ></ng-container>
        </div>
      </la-toggle-list-item>
    </ng-container>
  </la-toggle-list>
</ng-template>

<ng-template #cardTmpl let-data>
  <lockton-apps-dynamic-form-card
    @listItem
    (@listItem.done)="scrollToForm($event)"
    class="w-100 position-relative"
    [withinExpansion]="data.expansion"
    [fields]="props.fields"
    [item]="data.item"
    [invalid]="data.invalid"
    [distinctBy]="props.distinctBy"
    [distinctToggleListBy]="props.cache.toggleList?.distinctBy"
    [readonly]="props.readonly"
    [summary]="props.cache.toggleList?.summary"
    (edit)="edit(data.index)"
    (delete)="delete(data.index)"
    (customEvent)="onCustomEvent($event)"
  ></lockton-apps-dynamic-form-card>
</ng-template>

<ng-template #addAnotherControl let-data>
  <button
    class="d-flex"
    iconPosition="start"
    luiCab
    size="lg"
    type="button"
    [disabled]="data.disabled"
    (click)="addAnother(true)"
  >
    <mat-icon svgIcon="add"></mat-icon>
    <ng-container>{{ props.addAnotherText }}</ng-container>
  </button>
</ng-template>
